'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDatabaseCheck, iconDatabaseCheckTag } from '@ni/nimble-components/dist/esm/icons/database-check';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDatabaseCheck };
export { iconDatabaseCheckTag };
export const NimbleIconDatabaseCheck = wrap(IconDatabaseCheck);